import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  FormGroup,
  Input,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { isValidUrl } from '../../helpers/Validators';

import ErrorBoundary from '../ErrorBoundary';

class AddUrlModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: '',
      error: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleAddUrl = this.handleAddUrl.bind(this);
  }

  handleChange(e) {
    const { value } = e.target;
    this.setState({
      url: value,
      error: false,
    });
  }

  handleEnter(e) {
    if (e.key === 'Enter') {
      this.handleAddUrl();
    }
  }

  handleAddUrl() {
    const {
      handleAddUrl,
      handleClose,
    } = this.props;
    const { url } = this.state;

    if (!isValidUrl(url)) {
      this.setState({ error: true });
      return;
    }

    handleAddUrl(url);
    handleClose();
  }

  render() {
    const { intl, handleClose } = this.props;
    const {
      url,
      error,
    } = this.state;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose}>
          {intl.formatMessage({ defaultMessage: 'Add URL' })}
        </ModalHeader>
        <ModalBody style={{ overflow: 'visible' }}>
          <Form className="add-url-form" onSubmit={(e) => { e.preventDefault(); }}>
            <FormGroup>
              <Input
                type="text"
                id="url"
                name="url"
                className="url"
                placeholder={intl.formatMessage({ defaultMessage: 'Enter URL' })}
                value={url}
                autoFocus={true}
                invalid={error}
                onChange={this.handleChange}
                onKeyUp={this.handleEnter}
              />
              <Button
                disabled={!url}
                onClick={this.handleAddUrl}
              >
                <i className="far fa-plus" />
              </Button>
            </FormGroup>
            {error && (
              <div className="invalid-feedback">
                {intl.formatMessage({ defaultMessage: 'This URL looks incorrect' })}
              </div>
            )}
          </Form>
        </ModalBody>
      </ErrorBoundary>
    );
  }
}

AddUrlModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleAddUrl: PropTypes.func.isRequired,
};

export default injectIntl(AddUrlModal);
